import { Dictionary } from 'lodash';
import { Dispatcher, Store } from '../';
import { GlobalNotification } from '../../models';
import { GLOBALNOTIFICATION_UPDATE } from './globalNotifications.constants';


export interface IGlobalNotificationsActionCreatorService {
    addOne(notification: GlobalNotification): Dispatcher<void>;
    removeOne(guid: string): Dispatcher<void>;
}

export class GlobalNotificationsActionCreatorService implements IGlobalNotificationsActionCreatorService {
    static serviceId = 'globalNotificationsActionCreatorService';
    static $inject = ['$q'];

    private _notifications: Dictionary<GlobalNotification> = {};

    constructor(private _$q: angular.IQService) {
    }

    addOne(notification: GlobalNotification): Dispatcher<void> {
        return (dispatch: any, getState: () => Store) => {
            this._notifications[notification.guid] = notification;
            dispatch({ type: GLOBALNOTIFICATION_UPDATE, payload: this._notifications });
            return this._$q.when();
        };
    }

    removeOne(guid: string): Dispatcher<void> {
        return (dispatch: any, getState: () => Store) => {
            if (this._notifications[guid]) {
                delete this._notifications[guid];
            }
            dispatch({ type: GLOBALNOTIFICATION_UPDATE, payload: this._notifications });
            return this._$q.when();
        };
    }
}